/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/KubernetesEndpointHelper" />
import * as JSYaml from "js-yaml";
import * as Utils_String from "VSS/Core/Util/String";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { KubernetesCluster, KubernetesClusterData, ParseServiceAccountSecretYamlResponse } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/KubernetesEndpointContracts";

export class KubernetesClusterHelper {
    public static getTokenAndCertificateFromSecretYaml(serviceAccountSecretYaml: string): Promise<ParseServiceAccountSecretYamlResponse> {
        return new Promise((resolve, reject) => {
            try {
                let result: ParseServiceAccountSecretYamlResponse = { token: "", certificate: "" };
                let parsedServiceAccountSecret = JSYaml.safeLoad(serviceAccountSecretYaml);
                if (!parsedServiceAccountSecret) {
                    throw Resources.KuberntesInvalidServiceAccountSecretYaml;
                }

                if (!parsedServiceAccountSecret.data) {
                    throw Utils_String.localeFormat(Resources.KubernetesServiceAccountSecretFieldNotPresent, "data");
                }

                if (!parsedServiceAccountSecret.data.token) {
                    throw Utils_String.localeFormat(Resources.KubernetesServiceAccountSecretFieldNotPresent, "data.token");
                }

                if (!parsedServiceAccountSecret.data["ca.crt"]) {
                    throw Utils_String.localeFormat(Resources.KubernetesServiceAccountSecretFieldNotPresent, "data[ca.crt]");
                }

                result.token = parsedServiceAccountSecret.data.token;
                result.certificate = parsedServiceAccountSecret.data["ca.crt"];

                resolve(result);
            }
            catch (error) {
                reject(error);
            }
        });
    }

    public static getClusterContexts(kubeConfig: string, clusterContext: string): Promise<KubernetesClusterData> {
        return new Promise((resolve, reject) => {
            let kubernetesClusterData: KubernetesClusterData = { selectedCluster: { context: "", url: "" }, clusterList: [] };

            try {
                const parsedKubeConfig = JSYaml.safeLoad(kubeConfig);
                const currentContextText: string = "current-context";

                if (!parsedKubeConfig || !parsedKubeConfig.clusters) {
                    throw Utils_String.localeFormat(Resources.KubernetesInvalidKubeConfig);
                }

                parsedKubeConfig.contexts.forEach((context: any) => {
                    let kubeCluster: KubernetesCluster = { context: "", url: "" };

                    if (!context.name) {
                        throw Utils_String.localeFormat(Resources.KubernetesKubeConfigFieldNotPresent, "context.name");
                    }

                    kubeCluster.context = context.name;

                    if (!context.context.cluster) {
                        throw Utils_String.localeFormat(Resources.KubernetesKubeConfigFieldNotPresent, "context.context.cluster");
                    }

                    const cluster = parsedKubeConfig.clusters.find((c: any) => Utils_String.equals(c.name, context.context.cluster, true));
                    if (!cluster) {
                        throw Utils_String.localeFormat(Resources.KubernetesKubeConfigFieldNotPresent, "cluster");
                    }

                    if (!cluster.cluster.server) {
                        throw Utils_String.localeFormat(Resources.KubernetesKubeConfigFieldNotPresent, "cluster.cluster.server");
                    }

                    kubeCluster.url = cluster.cluster.server;
                    kubernetesClusterData.clusterList.push(kubeCluster);

                    if (!clusterContext) {
                        let currentContext = this._getKubeConfigFieldValue(parsedKubeConfig, currentContextText);

                        if (!!currentContext && kubeCluster.context === currentContext) {
                            kubernetesClusterData.selectedCluster.context = kubeCluster.context;
                            kubernetesClusterData.selectedCluster.url = kubeCluster.url;
                        }
                    }
                });

                resolve(kubernetesClusterData);
            }
            catch (error) {
                reject(error);
            }
        });
    }

    private static _getKubeConfigFieldValue(inputs: any, keyField: string): any {
        let keys = Object.keys(inputs);
        if (keys.length > 0) {
            let keyFound = keys.find(function (key) {
                return Utils_String.equals(key, keyField, true);
            });

            return inputs[keyFound];
        }

        return null;
    }
}
